export const MAX_LENGTH_VEHICLE_REG = 17;
export const MAX_LENGTH_ILU_CODE = 17;
export const MAX_LENGTH_EMPTY_VEHICLE_WEIGHT = 6;
export const MAX_LENGTH_GOODS_WEIGHT = 5;
export const MAX_LENGTH_LENGTH = 6;
export const MAX_LENGTH_WIDTH = 6;
export const MAX_LENGTH_HEIGHT = 6;
export const MAX_LENGTH_CUSTOMER_REFERENCE = 17;
export const MAX_LENGTH_LOADING_NOTE = 130;
